export const getFirstMultiDigitNumber = function(text) {
  const number = text.replace(/(^.+\D)(\d+)(\D.+$)/i, '$2');
  return number;
}